const autoNgTemplateLoaderTemplate1 = require('./kube-config-download-button.html');

import angular from 'angular';
import controller from './kube-config-download-button.controller';

angular.module('portainer.kubernetes').component('kubeConfigDownloadButton', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
});
